import api from './api';

import type { UserDirectoryEntry } from '@/types/directory';

export const directoryService = {
  getDirectory: async (): Promise<UserDirectoryEntry[]> => {
    const response = await api.get<UserDirectoryEntry[]>('/resources/directory');
    return response.data;
  },
};
